import React, { Component, Fragment } from 'react'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'
import Undo from 'material-ui/svg-icons/content/undo'
import CircularProgress from '@material-ui/core/CircularProgress'
import ActionDelete from 'material-ui/svg-icons/action/delete'
import IconButton from '@material-ui/core/IconButton'
import ImageEdit from 'material-ui/svg-icons/image/edit'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import { connect } from 'react-redux'
import { dcbNamesActions, confirmActions, messageActions } from '../../actions'
import TablePagination from '@material-ui/core/TablePagination'
import Typography from '@material-ui/core/Typography'
import { listTableStyle } from '../../styles'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import { reloadTable } from '../../utils/reloadTable'
import { findPermission, readOnly } from '../../utils/permissions'
import Visibility from '@material-ui/icons/Visibility'

class ListTable extends Component {
  state = {
    debounce: undefined
  }

  componentWillUpdate(newProps) {
    const { pagination, order, fetchNamesDcb, term } = newProps
    const { page, rowsPerPage: perPage } = pagination

    if (reloadTable(newProps, this.props)) {
      const debounce = setTimeout(() => {
        fetchNamesDcb({ page, perPage, order, term })
      }, 700)

      this.setState(state => {
        clearTimeout(state.debounce)
        return { debounce }
      })
    }
    return true
  }

  componentDidMount() {
    const { fetchNamesDcb } = this.props
    fetchNamesDcb()
  }

  handleParsingString(term) {
    var str = (term || []).join(', ')

    return str
  }

  handleChangePage = (event, page) => {
    const { pagination, handleChangePage, fetchNamesDcb, term } = this.props
    handleChangePage(page)
  }

  handleChangeRowsPerPage = event => {
    const perPage = event.target.value
    const { pagination, fetchNamesDcb, handleChangePerPage, term } = this.props
    handleChangePerPage(perPage)
  }

  handleSortTable = column => {
    const { order, changeOrderColumn, changeOrderDirection } = this.props
    if (column === ((order || {}).column || '')) {
      const direction = ((order || {}).direction || 1) === -1 ? 1 : -1
      changeOrderDirection(direction)
    } else {
      changeOrderColumn(column)
    }
  }

  renderActions = nameDcb => {
    const { fetchNameDcb, deleteNameDcb, addConfirm, token, restoreNameDcb } = this.props

    return (
      <Fragment>
        {readOnly('nomesDcb', token) &&
          !nameDcb.deletedAt && (
            <IconButton
              onClick={() => {
                fetchNameDcb(nameDcb._id)
              }}
            >
              <Visibility nativeColor={'rgba(0, 0, 0, 0.87)'} />
            </IconButton>
          )}

        {!!nameDcb.deletedAt && findPermission('nomesDcb', token).remover ? (
          <IconButton
            onClick={() => {
              const { changeMessage } = this.props

              addConfirm({
                confirmMessage: 'Confirma a restauração deste nome dcb?',
                confirmFunction: () => {
                  restoreNameDcb(nameDcb._id)
                  changeMessage({ message: 'Restauração realizada com sucesso.' })
                }
              })
            }}
          >
            <Undo />
          </IconButton>
        ) : (
          <Fragment>
            {findPermission('nomesDcb', token).editar && (
              <IconButton
                onClick={() => {
                  fetchNameDcb(nameDcb._id)
                }}
              >
                <ImageEdit />
              </IconButton>
            )}

            {findPermission('nomesDcb', token).remover && (
              <IconButton
                onClick={() => {
                  const { changeMessage } = this.props

                  addConfirm({
                    confirmMessage: 'Confirma a exclusão deste nome DCB?',
                    confirmFunction: () => {
                      deleteNameDcb(nameDcb._id)
                      changeMessage({ message: 'Exclusão realizada com sucesso.' })
                    }
                  })
                }}
              >
                <ActionDelete />
              </IconButton>
            )}
          </Fragment>
        )}
      </Fragment>
    )
  }

  render() {
    const { classes, namesDcb = [], loadingNamesDcb, pagination, order = {} } = this.props
    return (
      <Paper className={classes.wrapperTable} elevation={4}>
        {!!loadingNamesDcb && (
          <div className={classes.wrapperLoader}>
            <CircularProgress />
          </div>
        )}
        <Table
          fixedHeader={true}
          wrapperStyle={{
            display: 'flex',
            flexDirection: 'column',
            maxHeight: 'var(--crud-table-height)'
          }}
          width={'990px'}
        >
          <TableHeader
            displaySelectAll={false}
            className={classes.tableHeader}
            adjustForCheckbox={false}
          >
            <TableRow>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'nome'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('nome')
                  }}
                >
                  Nome
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'sinonimos'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('sinonimos')
                  }}
                >
                  Sinônimos
                </TableSortLabel>
              </TableHeaderColumn>

              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'numero_cas'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('numero_cas')
                  }}
                >
                  Numero CAS
                </TableSortLabel>
              </TableHeaderColumn>

              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'receita_tipo'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('receita_tipo')
                  }}
                >
                  Tipo de Receita
                </TableSortLabel>
              </TableHeaderColumn>

              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'classificacoesAtc'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('classificacoesAtc')
                  }}
                >
                  Classificação ATC
                </TableSortLabel>
              </TableHeaderColumn>

              <TableHeaderColumn style={{ width: '100px' }}>Ações</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {(namesDcb || []).length ? (
              (namesDcb || []).map(nameDcb => {
                return (
                  <TableRow key={nameDcb._id}>
                    <TableRowColumn>{nameDcb.nome}</TableRowColumn>
                    <TableRowColumn>
                      {this.handleParsingString(nameDcb.sinonimos) || []}
                    </TableRowColumn>
                    <TableRowColumn>{nameDcb.numero_cas}</TableRowColumn>
                    <TableRowColumn>{nameDcb.receita_tipo}</TableRowColumn>
                    <TableRowColumn>
                      {(nameDcb.classificacoesAtc || [])
                        .map(record => record && record.nome)
                        .join(', ')}
                    </TableRowColumn>
                    <TableRowColumn style={{ width: '100px' }}>
                      {this.renderActions(nameDcb)}
                    </TableRowColumn>
                  </TableRow>
                )
              })
            ) : (
              <TableRow>
                <TableRowColumn>
                  <Typography noWrap style={{ textAlign: 'center', padding: '16px' }}>
                    {!!loadingNamesDcb ? 'Carregando...' : 'Não há registros.'}
                  </Typography>
                </TableRowColumn>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <div className={classes.paginationWrapper}>
          <div className={classes.page}>Página: {pagination.page + 1}</div>
          <TablePagination
            component="div"
            className={classes.pagination}
            labelRowsPerPage="Itens por página"
            labelDisplayedRows={({ from, to, count, page }) => {
              return `Exibindo de ${from} a ${to} de ${count}`
            }}
            rowsPerPageOptions={[25, 50, 100]}
            count={pagination.length}
            rowsPerPage={pagination.rowsPerPage}
            page={pagination.page}
            backIconButtonProps={{
              'aria-label': 'Página anterior'
            }}
            nextIconButtonProps={{
              'aria-label': 'Próxima página'
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </div>
      </Paper>
    )
  }
}

const mapStateToProps = state => {
  return {
    nameDcb: state.namesDcb.nameDcb,
    namesDcb: state.namesDcb.namesDcb,
    loadingNamesDcb: state.namesDcb.loadingNamesDcb,
    token: state.auth.token,
    pagination: state.namesDcb.namesDcbPagination,
    order: state.namesDcb.order,
    term: state.searchTable.term
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(dcbNamesActions.openModal())
    },
    closeModal: () => {
      dispatch(dcbNamesActions.closeModal())
    },
    fetchNameDcb: id => {
      dispatch(dcbNamesActions.fetchNameDcb(id))
    },
    fetchNamesDcb: options => {
      dispatch(dcbNamesActions.fetchNamesDcb(options))
    },
    deleteNameDcb: id => {
      dispatch(dcbNamesActions.deleteNameDcb(id))
    },
    addConfirm: ({ confirmMessage, confirmFunction }) => {
      dispatch(confirmActions.addFunction({ confirmMessage, confirmFunction }))
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    },
    handleChangePage: page => {
      dispatch(dcbNamesActions.handleChangePage(page))
    },
    handleChangePerPage: perPage => {
      dispatch(dcbNamesActions.handleChangePerPage(perPage))
    },
    restoreNameDcb: id => {
      dispatch(dcbNamesActions.restoreNameDcb(id))
    },
    changeOrderColumn: column => {
      dispatch(dcbNamesActions.changeOrderColumn(column))
    },
    changeOrderDirection: direction => {
      dispatch(dcbNamesActions.changeOrderDirection(direction))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(listTableStyle)(ListTable))



// WEBPACK FOOTER //
// ./src/containers/DcbNames/ListTable.js